import { useRouter } from 'next/router';

import { IconWell } from '@playbooks/molecules/icons/icon-well';
import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';
import { truncate } from '@playbooks/utils';

export const TableAvatar = ({
	icon = 'database',
	thumbnail = null,
	title,
	length = 30,
	href = null,
	className = '',
}) => {
	const router = useRouter();
	const params = new URLSearchParams({ archived: router.query.archived?.toString() });
	const url = router.query.archived ? href + '?' + params.toString() : href;

	// Theme
	const rootClassName = cn('group shrink-0 h-auto p-0', className);

	// Render
	return (
		<Link variant='ghost' href={url} aria-label={title} className={rootClassName}>
			<Avatar className='flex-start shrink-0'>
				{thumbnail ? (
					<AvatarImage src={thumbnail} alt={title} className='size-6' />
				) : (
					<IconWell icon={icon} size='2xs' />
				)}
				<AvatarContent className='shrink-0 group-hover:underline'>
					<AvatarDescription className='text-foreground/80 transition-colors group-hover:text-foreground'>
						{truncate(title, length)}
					</AvatarDescription>
				</AvatarContent>
			</Avatar>
		</Link>
	);
};
